module.exports = __webpack_public_path__ + "media/product/tr-1-986463ce.png";